// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"96b2e611e0fdcb48","2928":"4e687847e817f4e2"}[chunkId] + ".css";
};